import { MessageRole } from '@multiplayer-app/ai-agent-types'
import { MarkdownMessage } from './MarkdownMessage'

interface MessageContentProps {
  content: string
  role: MessageRole
}

export const MessageContent = ({ content, role }: MessageContentProps) => {
  const isUser = role === MessageRole.User
  const isError = role === MessageRole.Error
  const isReasoning = role === MessageRole.Reasoning

  // Trim outer whitespace: with pre-wrap, a trailing newline in the stored
  // content renders as a phantom empty line inside the bubble.
  if (isUser) {
    return <p style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{content.trim()}</p>
  }

  if (isError) {
    return <p style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{content.trim()}</p>
  }

  if (isReasoning) {
    return <pre style={{ margin: 0, fontSize: '13px', opacity: 0.8 }}>{content}</pre>
  }

  return <MarkdownMessage text={content} />
}
